<ng-container *ngIf="componentData.includeCallToAction; else baseIcon">
    <a [href]="callToActionUrl">
        <div class="gallery-item" >
            <img [src]="iconImagePath" alt="">
            <p>{{translationRoot | translate:useLocaleOverride}}</p>
        </div>
    </a>
</ng-container>

<ng-template #baseIcon>
    <div class="gallery-item" >
        <img [src]="iconImagePath" alt="">
        <p>{{translationRoot | translate:useLocaleOverride}}</p>
    </div>
</ng-template>


